export default __webpack_public_path__ + "static/media/bg_customer.65897930.png";